import { RedirectRequest } from '@azure/msal-browser';

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const buildLoginRequest = (redirectUri: string, scopes: string[]): RedirectRequest => ({
  scopes,
  redirectUri,
});
